export function isObject(value: any): value is Record<string, any> {
    const type = typeof value;
    return value != null && (type === "object" || type === "function");
}

export const isArray = (possibleArray: any): boolean =>
    Array.isArray(possibleArray);

export const isIterable = (value: any): value is Iterable<any> => {
    if (!value) return false;
    if (typeof value !== "object") return false;

    return Symbol.iterator in value;
};

export const isString = (value: any): value is string => {
    return typeof value === "string";
};

export const parseBoolean = (value?: any): boolean => {
    return !(
        value === "false" ||
        value === "0" ||
        value === "" ||
        value === undefined
    );
};
